export default __webpack_public_path__ + "static/media/way_2.7881456e.jpg";